'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LIVE_SEEK_SET_DURATION_ERROR = exports.LIVE_SEEK_SET_DURATION_ERROR = 'liveSeek.setDuration.error';
var LIVE_SEEK_PLAY_ERROR = exports.LIVE_SEEK_PLAY_ERROR = 'liveSeek.play.error';
var LIVE_SEEK_LOAD_ERROR = exports.LIVE_SEEK_LOAD_ERROR = 'liveSeek.load.error';
var LIVE_SEEK_SEEK_ERROR = exports.LIVE_SEEK_SEEK_ERROR = 'liveSeek.seek.Error';
//# sourceMappingURL=logging.js.map